import React from 'react';
import './App.css';
import MapView from "./features/map/MapView";
import { ToastContainer } from "./features/ui/ToastContainer";

function App() {
    return (
        <div className="App">
            <ToastContainer />
            <MapView />
        </div>
    );
}

export default App;
